import ApplicationComponent from "legacy/ApplicationComponent"
import DeprecatedOldReactAdapterComponentContainer from "legacy/dangerous/DeprecatedOldReactAdapterComponentContainer"
import PropTypes from "prop-types"
import React from "react"

class ReservationItinerarySection extends ApplicationComponent {
  render() {
    return (
      <DeprecatedOldReactAdapterComponentContainer id="itinerary-section-mbm">
        <div className="mb-3 space-y-3">
          <a
            href={`${this.props.manageUrl}/reservations/night/${this.props.checkInDate}`}
            target="_blank"
            rel="noreferrer"
            className="flex flex-col"
          >
            <span className="text-xs md:text-sm">
              {this.props.hasContractQuote ? "Start date" : "Arrival"}
            </span>
            <span className="text-xs md:text-sm">
              {this.props.formattedCheckInDate}
            </span>
          </a>
          <div className="flex flex-col">
            <span className="text-xs md:text-sm">
              {this.props.hasContractQuote ? "End date" : "Departure"}
            </span>
            <span className="text-xs md:text-sm">
              {this.props.checkOutDate}
            </span>
          </div>
        </div>
      </DeprecatedOldReactAdapterComponentContainer>
    )
  }
}

ReservationItinerarySection.propTypes = {
  manageUrl: PropTypes.string.isRequired,
  checkInDate: PropTypes.string.isRequired,
  formattedCheckInDate: PropTypes.string.isRequired,
  checkOutDate: PropTypes.string.isRequired,
  hasContractQuote: PropTypes.bool,
}

export default ReservationItinerarySection
